import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import styles from './index.module.scss'
import API, { commonApiInvoker } from '@api/api'
import { Button, Divider, Empty, Image, Input, message, Modal, Select, Space, Spin, Checkbox, Radio } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import InfiniteScroll from 'react-infinite-scroll-component'
import Utils from "@utils/utils"
import PictureViewer from '@view/compoents/PictureViewer';
import eventBus from '@utils/eventBus';
import { useLocation } from 'react-router-dom'
import { flushSync } from 'react-dom'
import PSAIModal from "@PSAIComponents/PSAIModal";
import JSZip from 'jszip'
import axios from 'axios'
import { saveAs } from "file-saver";
import DeliveryDetailActions from "../DeliveryDetailActions";
import DeliveryItem from "../DeliveryItem";
import DeliveryImageItem from "../DeliveryImageItem";
import { AppContext } from '@utils/AppContext';
import { downloadWhitelist } from '@/utils/CONST'
import { formatFilenameByRule } from '../../DownloadFunc';

const DeliveryDetail = forwardRef(({
    version,
    searchText,
    onDownload,
    viewMode, // 视图：1-商品列表 2-图片大图列表 3-图片小图列表
    onViewModeChange
}, ref) => {
    useImperativeHandle(ref, () => ({
        updateForce: () => updateForce({}),
    }))

    const { globalUser } = useContext(AppContext)

    const pageRef = useRef(1)
    const pageSizeRef = useRef(100)
    const [dataSource, setDataSource] = useState([])
    const [total, setTotal] = useState(0)
    const [deliveryInfo, setDeliveryInfo] = useState()
    const [force, updateForce] = useState()
    // 批量操作
    const [allRows, setAllRows] = useState([])
    const [isMultiSelect, setIsMultiSelect] = useState(false)
    const [selectRowKeys, setSelectRowKeys] = useState([])
    const [multiRejectOpen, setMultiRejectOpen] = useState(false)
    const [multiRejectLoading, setMultiRejectLoading] = useState(false)
    const [multiRejectReason, setMultiRejectReason] = useState('')

    const getDeliveryInfoByVersion = useCallback(() => {
        if (!version) return
        commonApiInvoker(API.getDeliveryInfoByVersion({
            deliveryVersion: version,
        })).then(res => {
            setDeliveryInfo(res)
        })
    }, [version])
    const refreshData = useCallback(() => {
        console.log('==refreshData==')
        if (!version) return
        pageRef.current = 1
        const params = new URLSearchParams()
        params.append('version', version)
        params.append('pageIndex', pageRef.current)
        params.append('pageSize', pageSizeRef.current)
        // 因为搜索货号时，有数据的没有排在前面，可能不会触发下拉分页
        // 所以这里需要查出全部数据
        if (searchText) {
            params.append('skuCode', searchText)
            return commonApiInvoker(API.listDeliveryByVersion(params), false, true).then(res => {
                const items = res.items || []
                const total = res.total || 0
                if (items.length < total) {
                    const params = new URLSearchParams()
                    params.append('version', version)
                    params.append('pageIndex', pageRef.current)
                    params.append('pageSize', total)
                    params.append('skuCode', searchText)
                    return commonApiInvoker(API.listDeliveryByVersion(params), false, true).then(res => {
                        const items = res.items || []
                        const total = res.total || 0
                        setDataSource(items)
                        setTotal(total)
                        return total
                    })
                } else {
                    setDataSource(items)
                    setTotal(total)
                    return total
                }                
            }).catch(err => {
                console.error(err)
            })
        } else {
            return commonApiInvoker(API.listDeliveryByVersion(params), false, true).then(res => {
                const items = res.items || []
                const total = res.total || 0
                setDataSource(items)
                setTotal(total)
                return total
            }).catch(err => {
                console.error(err)
            })
        }
    }, [version, searchText])
    const fetchData = useCallback(() => {
        console.log('==fetchData==')
        pageRef.current += 1
        const params = new URLSearchParams()
        params.append('version', version)
        params.append('pageIndex', pageRef.current)
        params.append('pageSize', pageSizeRef.current)
        if (searchText) params.append('skuCode', searchText)
        commonApiInvoker(API.listDeliveryByVersion(params)).then(res => {
            const items = res.items || []
            const total = res.total || 0
            setDataSource(pre => [...pre, ...items])
            setTotal(total)
        })
    }, [version, searchText])
    const getAllRows = useCallback(async (total) => {
        try {
            if (!version) return
            if (!total) return
            const params = new URLSearchParams()
            params.append('version', version)
            params.append('pageIndex', 1)
            params.append('pageSize', total)
            if (searchText) params.append('skuCode', searchText)
            const res = await commonApiInvoker(API.listDeliveryByVersion(params), false, true)
            const dataSource = res.items || []
            const allRows = dataSource.flatMap(item => item.skuDeliveryList)
            setAllRows(allRows)
            return allRows
        } catch (err) {
            console.error(err)
        }
    }, [version, searchText])
    useEffect(() => {
        refreshData().then(getAllRows)
        getDeliveryInfoByVersion()
    }, [refreshData, getDeliveryInfoByVersion, getAllRows, force])

    const hasMore = useMemo(() => {
        return dataSource.length < total
    }, [total, dataSource])

    const [pictureViewOpen, setPictureViewOpen] = useState(false)
    const [pictureViewData, setPictureViewData] = useState([])
    const [pictureViewDefaultIndex, setPictureViewDefaultIndex] = useState(0)
    const buildPictureViewerData = useCallback((rows = []) => {
        return rows.flatMap(item => {
            return item.skuDeliveryList.map(item2 => {
                const skuId = item2.skuCode || item2.skuNumber
                return item2.deliveryImages.map(item3 => {
                    const extraImages = []
                    // 处理质检图上的标注
                    let annotations = []
                    const status = item3.status // 1已交付 2 已交付通过 3 已交付不通过
                    const refine = item3.refine // 已微调
                    const userPrevImage = item3.userPrevImage // 质检图
                    if ((status == 0 || status == 1) && refine) { // 微调图，标注显示在质检图上
                        annotations = []
                        extraImages.push({
                            label: '质检图',
                            url: userPrevImage?.image,
                            annotations: userPrevImage?.annotations || [],
                        })
                    } else if (status == 2) { // 交付通过，不显示标注
                        annotations = []
                    } else {
                        annotations = userPrevImage?.annotations || []
                    }
                    if ((item2.deliveryTypes && item2.deliveryTypes.includes("reference")) || !item2.deliveryTypes) {
                        const refImages = item3.refImages || []
                        if (refImages.length > 0) extraImages.push(...refImages.map(item => ({ label: '参考图', url: item.url })))
                        else if (item3.refImage) extraImages.push({
                            label: '参考图',
                            url: item3.refImage
                        })
                    }
                    if ((item2.deliveryTypes && item2.deliveryTypes.includes("origin")) || !item2.deliveryTypes) {
                        if (item3.skuImage) extraImages.push({
                            label: '源素材',
                            url: item3.skuImage
                        })
                    }
                    if ((item2.deliveryTypes && item2.deliveryTypes.includes("match")) || !item2.deliveryTypes) {
                        const matchImages = item3.matchImages || []
                        if (matchImages.length > 0) extraImages.push(...matchImages.map(item => ({ label: '搭配图', url: item.url })))
                        else if (item3.matchClothImage) extraImages.push({
                            label: '搭配图',
                            url: item3.matchClothImage
                        })
                    }
                    // 在白名单中的用户，通过且反馈图，可编辑
                    const inWhitelist = downloadWhitelist.includes(globalUser.mobile)
                    return {
                        id: item3.imageId,
                        name: '交付图',
                        url: item3.url,
                        status: item3.status == 2 ? 'approved' : item3.status == 3 ? 'rejected' : item3.status == -1 ? 'canceled' : item3.refine ? 'modified' : null,
                        annotations: annotations,
                        annotationHistory: [],
                        title: skuId || '-',
                        approveText: '通过',
                        approvedText: '通过',
                        rejectText: '不通过',
                        rejectedText: '不通过',
                        rejectDisabled: item3.status == -1,
                        cancelDisabled: true,
                        readOnly: !!(item3.deliverySubmit && (item3.status == 2 || item3.status == -1)),
                        // readOnly: inWhitelist ? !!(item3.deliverySubmit && item3.status == -1) : !!(item3.deliverySubmit && (item3.status == 2 || item3.status == -1)),
                        shouldCommitOnLeave: false,
                        extraInfos: [
                            { label: '批次', value: version },
                        ],
                        extraImages,
                        _raw: {
                            deliveryId: item2.id,
                            imageId: item3.imageId,
                        }
                    }
                })
            }).flat()
        })
    }, [version, globalUser])
    const handlePreview = useCallback(async ({imageId, skuId, spuId}) => {
        try {
            const params = new URLSearchParams()
            params.append('version', version)
            params.append('pageIndex', 1)
            params.append('pageSize', total)
            if (searchText) params.append('skuCode', searchText)
            const res = await commonApiInvoker(API.listDeliveryByVersion(params), false, true)
            const dataSource = res.items || []
            const images = buildPictureViewerData(dataSource)
            const currentIndex = images.findIndex(item => item.id == imageId)
            setPictureViewData(images)
            setPictureViewDefaultIndex(currentIndex >= 0 ? currentIndex : 0)
            setPictureViewOpen(true)
        } catch (err) {
            console.error(err)
        }
    }, [total, version, searchText, buildPictureViewerData])
    const onPreviewClose = useCallback(async () => {
        // 检查所有图片是否已标记且可提交反馈
        try {
            getDeliveryInfoByVersion()
            const total = await refreshData()
            const allRows = await getAllRows(total)
            if (!allRows) return
            // 筛选出可以提交反馈的数据
            const checkAllImageSubmited = (item) => {
                const deliveryImages = item.deliveryImages || []
                return deliveryImages.every(item => !!item.deliverySubmit)
            }
            const checkAllImageMarked = (item) => {
                const deliveryImages = item.deliveryImages || []
                return deliveryImages.every(item => {
                    return item.status == 2 || // 已通过/已下载
                        item.status == 3 || // 不通过
                        item.status == -1 // 已取消
                })
            }
            // 检查所有图片已标记时，才可以提交反馈
            const allImageMarked = allRows.every(item => checkAllImageMarked(item))
            if (!allImageMarked) return
            const availbleRows = allRows.filter(item => {
                const allImageSubmited = checkAllImageSubmited(item)
                const allImageMarked = checkAllImageMarked(item)
                if (!(!allImageSubmited && allImageMarked)) return false
                return true
            })
            if (availbleRows.length == 0) return
            // 已通过图片数
            const approvedCount = availbleRows.flatMap(item => item.deliveryImages || []).filter(item => item.status == 2 && !item.deliverySubmit).length
            // 不通过图片数
            const rejectedCount = availbleRows.flatMap(item => item.deliveryImages || []).filter(item => item.status == 3 && !item.deliverySubmit).length
            const res = await submitConfirm(approvedCount, rejectedCount)
            if (!res) return
            await commonApiInvoker(API.merchantFeedback({
                deliveryIds: availbleRows.map(item => item.id),
            }), false, true)
            message.success('提交反馈成功')
            updateForce({})
            eventBus.emit('updatePower')
        } catch (err) {
            console.error(err)
        } finally {
            setPictureViewOpen(false)
        }
    }, [refreshData, getDeliveryInfoByVersion, getAllRows])
    const handlePictureStatusChange = useCallback(async ({id, status, annotation}, rawItem) => {
        const isApproved = status === 'approved'
        await commonApiInvoker(API.merchantJudge({
            deliveryId: rawItem?.deliveryId,
            imageId: id,
            pass: isApproved,
            annotations: annotation,
        }), false, true)
    }, [])
    const submitFeedback = useCallback((deliveryIds, callback) => {
        return commonApiInvoker(API.merchantFeedback({
            deliveryIds
        }), false, true).then(res => {
            updateForce({})
            eventBus.emit('updatePower')
            message.success('提交反馈成功')
            if (callback) callback()
            return res
        })
    }, [])
    const getFeedbackSummary = useCallback((rows = allRows) => {
        const checkAllImageSubmited = (item) => {
            const deliveryImages = item.deliveryImages || []
            return deliveryImages.every(item => !!item.deliverySubmit)
        }
        const checkAllImageMarked = (item) => {
            const deliveryImages = item.deliveryImages || []
            return deliveryImages.every(item => {
                return item.status == 2 || // 已通过/已下载
                    item.status == 3 || // 不通过
                    item.status == -1 // 已取消
            })
        }
        const allImageSubmited = rows.length > 0 && rows.every(item => checkAllImageSubmited(item))
        const allImageMarked = rows.length > 0 && rows.every(item => checkAllImageMarked(item))
        const availbleRows = rows.filter(item => {
            const allImageSubmited = checkAllImageSubmited(item)
            const allImageMarked = checkAllImageMarked(item)
            if (!(!allImageSubmited && allImageMarked)) return false
            return true
        })
        const approvedCount = availbleRows.flatMap(item => item.deliveryImages || []).filter(item => item.status == 2 && !item.deliverySubmit).length
        const rejectedCount = availbleRows.flatMap(item => item.deliveryImages || []).filter(item => item.status == 3 && !item.deliverySubmit).length
        return {
            allImageSubmited,
            allImageMarked,
            availbleRows,
            approvedCount,
            rejectedCount,
        }
    }, [allRows])
    const submitStatus = useMemo(() => {
        const { allImageSubmited, allImageMarked } = getFeedbackSummary(allRows)
        if (allImageSubmited) return 'submitted'
        if (allImageMarked) return 'enabled'
        return 'disabled'
    }, [allRows, getFeedbackSummary])

    // 提交反馈
    const handleFeedbackSubmit = useCallback((deliveryIds, callback) => {
        PSAIModal.confirm({
            content: (
                <div style={{textAlign:"center"}}>
                    是否提交全部反馈？<br />
                    提交后，已通过的图片不可再修改审核状态
                </div>
            ),
            okText: '确认提交',
            cancelText: '取消',
            onOk () {
                return submitFeedback(deliveryIds, callback)
            }
        })
    }, [submitFeedback])
    const handleSubmitCurrentVersion = useCallback(async () => {
        if (allRows.length == 0) return message.warning('当前没有可提交反馈的商品')
        const { allImageMarked, availbleRows, approvedCount, rejectedCount } = getFeedbackSummary(allRows)
        if (!allImageMarked) return message.warning('请先完成当前批次全部图片的验收')
        if (availbleRows.length == 0) return message.warning('当前批次没有可提交反馈的商品')
        const res = await submitConfirm(approvedCount, rejectedCount)
        if (!res) return
        return submitFeedback(availbleRows.map(item => item.id))
    }, [allRows, getFeedbackSummary, submitFeedback])
    // 开启批量操作
    const onMultiSelect = useCallback((isSelect) => {
        setIsMultiSelect(isSelect)
        setSelectRowKeys([])
    }, [])
    // 批量下载
    const onMultiDownload = useCallback(() => {
        const targetTypeText = viewMode == 1 ? '商品' : '图片'
        if (selectRowKeys.length == 0) return message.warning(`请选择要下载的${targetTypeText}`)
        if (viewMode == 1) {
            const selectRows = allRows.filter(item => selectRowKeys.includes(item.id))
            onDownload(selectRowKeys, selectRows, () => {
                setSelectRowKeys([])
                setIsMultiSelect(false)
            })
            return
        }
        const selectedImageEntries = getSelectedImageEntries()
        if (selectedImageEntries.length == 0) return message.warning('请选择要下载的图片')
        const selectRows = Array.from(new Map(
            selectedImageEntries.map(({ row }) => [row.id, row])
        ).values())
        const imageIds = selectedImageEntries.map(({ imageItem }) => imageItem.imageId)
        const skuIds = selectRows.map(item => item.id)
        onDownload(skuIds, selectRows, () => {
            setSelectRowKeys([])
            setIsMultiSelect(false)
        }, imageIds)
    }, [selectRowKeys, allRows, viewMode, onDownload, getSelectedImageEntries])
    // 批量提交反馈
    const onMultiFeedback = useCallback(() => {
        if (selectRowKeys.length == 0) return message.warning('请选择要提交反馈的商品')
        const selectedRows = allRows.filter(item => selectRowKeys.includes(item.id))
        const availbleRowKeys = getFeedbackSummary(selectedRows).availbleRows.map(item => item.id)
        if (availbleRowKeys.length == 0) return message.warning('请选择可以提交反馈的批次')
        handleFeedbackSubmit(availbleRowKeys, () => {
            setSelectRowKeys([])
            setIsMultiSelect(false)
        })
    }, [selectRowKeys, allRows, getFeedbackSummary, handleFeedbackSubmit])
    const getSelectedDeliveryRows = useCallback(() => {
        return allRows.filter(item => selectRowKeys.includes(item.id))
    }, [allRows, selectRowKeys])
    const getSelectedImageEntries = useCallback(() => {
        return allRows.flatMap(row => {
            return (row.deliveryImages || [])
                .filter(imageItem => selectRowKeys.includes(imageItem.imageId))
                .map(imageItem => ({
                    row,
                    imageItem,
                }))
        })
    }, [allRows, selectRowKeys])
    const getBatchEditableImages = useCallback((rows = []) => {
        return rows.flatMap(row => {
            return (row.deliveryImages || [])
                .filter(imageItem => !(imageItem?.deliverySubmit && (imageItem?.status == 2 || imageItem?.status == -1)))
                .map(imageItem => ({
                    row,
                    imageItem,
                }))
        })
    }, [])
    const getBatchEditableTargets = useCallback(() => {
        if (viewMode == 1) {
            return getBatchEditableImages(getSelectedDeliveryRows())
        }
        return getSelectedImageEntries().filter(({ imageItem }) => {
            return !(imageItem?.deliverySubmit && (imageItem?.status == 2 || imageItem?.status == -1))
        })
    }, [viewMode, getBatchEditableImages, getSelectedDeliveryRows, getSelectedImageEntries])
    // 批量通过
    const onMultiApprove = useCallback(() => {
        const targetTypeText = viewMode == 1 ? '商品' : '图片'
        if (selectRowKeys.length == 0) return message.warning(`请选择要批量通过的${targetTypeText}`)
        const editableImages = getBatchEditableTargets()
        if (editableImages.length == 0) return message.warning(`所选${targetTypeText}没有可批量通过的图片`)
        PSAIModal.confirm({
            title: `确认通过选中的${targetTypeText}吗？`,
            okText: '确定',
            cancelText: '取消',
            onOk () {
                const promiseList = editableImages.map(({ row, imageItem }) => {
                    return commonApiInvoker(API.merchantJudge({
                        annotations: '',
                        deliveryId: row.id,
                        imageId: imageItem.imageId,
                        pass: true,
                    }), false, true)
                })
                return Promise.all(promiseList).then(() => {
                    message.success('批量通过成功')
                    setSelectRowKeys([])
                    setIsMultiSelect(false)
                    updateForce({})
                }).catch(err => {
                    console.error(err)
                    message.warning(err?.message || '批量通过失败')
                })
            }
        })
    }, [selectRowKeys, viewMode, getBatchEditableTargets])
    // 批量不通过
    const onMultiReject = useCallback(() => {
        const targetTypeText = viewMode == 1 ? '商品' : '图片'
        if (selectRowKeys.length == 0) return message.warning(`请选择要批量不通过的${targetTypeText}`)
        const editableImages = getBatchEditableTargets()
        if (editableImages.length == 0) return message.warning(`所选${targetTypeText}没有可批量不通过的图片`)
        setMultiRejectReason('')
        setMultiRejectOpen(true)
    }, [selectRowKeys, viewMode, getBatchEditableTargets])
    const handleMultiRejectSubmit = useCallback(() => {
        const rejectReason = multiRejectReason?.trim()
        if (!rejectReason) return message.warning('请填写修改意见')
        const editableImages = getBatchEditableTargets()
        if (editableImages.length == 0) {
            setMultiRejectOpen(false)
            return message.warning('所选内容没有可批量不通过的图片')
        }
        setMultiRejectLoading(true)
        const promiseList = editableImages.map(({ row, imageItem }) => {
            const historyAnnotations = imageItem?.userPrevImage?.annotations || []
            return commonApiInvoker(API.merchantJudge({
                annotations: [
                    ...getNoCommentAnnotations(historyAnnotations),
                    { comment: rejectReason, timestamp: Date.now() }
                ],
                deliveryId: row.id,
                imageId: imageItem.imageId,
                pass: false,
            }), false, true)
        })
        return Promise.all(promiseList).then(() => {
            message.success('批量不通过成功')
            setSelectRowKeys([])
            setIsMultiSelect(false)
            setMultiRejectOpen(false)
            updateForce({})
        }).catch(err => {
            console.error(err)
            message.warning(err?.message || '批量不通过失败')
        }).finally(() => {
            setMultiRejectLoading(false)
        })
    }, [multiRejectReason, getBatchEditableTargets])
    // 选择单个商品
    const onSelect = useCallback((item) => {
        let key
        if (viewMode == 1) {
            key = item.id
        } else {
            key = item.imageId
        }
        setSelectRowKeys(pre => {
            if (pre.includes(key)) {
                return pre.filter(item => item != key)
            } else {
                return [...pre, key]
            }
        })
    }, [viewMode])
    // 下载单个商品
    const handleDownload = useCallback((id) => {
        const selectRows = dataSource.flatMap(item => item.skuDeliveryList).filter(item => item.id == id)
        onDownload([id], selectRows, () => {
            setSelectRowKeys([])
            setIsMultiSelect(false)
        })
    }, [onDownload, dataSource])
    // 下载单张图片
    const handleImageDownload = useCallback(async (imageItem) => {
        try {
            const deliveryRow = dataSource
                .flatMap(item => item.skuDeliveryList)
                .find(item => item.id == imageItem?.deliveryId)
            if (!deliveryRow) {
                return message.warning('未找到图片对应的商品信息')
            }

            const deliveryImages = deliveryRow.deliveryImages || []
            const index = deliveryImages.findIndex(item => item.imageId == imageItem.imageId) + 1
            const images = await commonApiInvoker(API.listPassImages({
                skuIds: [],
                imageIds: [imageItem.imageId],
                onlyPassed: !downloadWhitelist.includes(globalUser.mobile),
            }), false, true)
            const targetImage = images?.[0]
            if (!targetImage?.deliveryImage) {
                return PSAIModal.info({
                    content: (
                        <div style={{textAlign:"center"}}>
                            仅支持下载已通过且已提交反馈的图片 <br />
                            其余图片请在通过验收后再下载
                        </div>
                    )
                })
            }

            const url = targetImage.deliveryImage
            const skuCode = Utils.sanitizeString(deliveryRow.skuCode || deliveryRow.skuNumber || imageItem?.skuCode || imageItem?.skuNumber || '')
            const deliveryNamingRule = globalUser?.deliveryNamingRule
            const filename = formatFilenameByRule({ skuCode, index }, deliveryNamingRule)
            const fileExtension = url.split('?')[0].split('.').pop() || 'jpg'
            const response = await axios.get(url, { responseType: 'blob' })

            saveAs(response.data, `${filename}.${fileExtension}`)
            message.success('下载成功')
            setSelectRowKeys([])
            setIsMultiSelect(false)
            updateForce({})
            eventBus.emit('updatePower')
        } catch (err) {
            console.error(err)
            message.error(`下载失败${err?.message ? `：${err.message}` : ''}`)
        }
    }, [dataSource, globalUser])
    // 全选
    const onSelectAll = useCallback(() => {
        if (viewMode == 1) {
            setSelectRowKeys(allRows.map(item2 => item2.id))
        } else {
            const imageIds = allRows.flatMap(row => {
                return (row.deliveryImages || []).filter(imageItem => {
                    if (isMultiSelect == 'download') {
                        if (downloadWhitelist.includes(globalUser.mobile)) return true
                        return imageItem?.status == 2 && !!imageItem?.deliverySubmit
                    }
                    return !(imageItem?.deliverySubmit && (imageItem?.status == 2 || imageItem?.status == -1))
                }).map(imageItem => imageItem.imageId)
            })
            setSelectRowKeys(imageIds)
        }
    }, [viewMode, allRows, isMultiSelect, globalUser])
    // 批量提交确认
    const onMultiSubmit = useCallback(() => {
        if (viewMode == 1) {
            if (isMultiSelect == 'approve') { // 通过
                onMultiApprove()
            } else if (isMultiSelect == 'reject') { // 不通过
                onMultiReject()
            } else if (isMultiSelect == 'feedback') { // 提交反馈
                onMultiFeedback()
            } else if (isMultiSelect == 'download') { // 下载
                onMultiDownload()
            }
        } else {
            if (isMultiSelect == 'approve') { // 通过
                onMultiApprove()
            } else if (isMultiSelect == 'reject') { // 不通过
                onMultiReject()
            } else if (isMultiSelect == 'download') { // 下载
                onMultiDownload()
            }
        }
    }, [
        viewMode, isMultiSelect, selectRowKeys,
        onMultiFeedback, onMultiDownload, onMultiApprove, onMultiReject
    ])
    // 全部图片列表
    const imageList = useMemo(() => {
        return dataSource.flatMap(item => item.skuDeliveryList.flatMap(item => item.deliveryImages.map(imageItem => ({
            ...imageItem,
            deliveryId: item.id,
        }))))
    }, [dataSource])
    // 图片通过
    const handleApprove = useCallback((imageId, deliveryId, needConfirm) => {
        const onOk = () => (
            API.merchantJudge({
                annotations: null,
                deliveryId: deliveryId,
                imageId: imageId,
                pass: true
            }).then(res => {
                if (res?.code != 0) throw new Error(res?.message)
                updateForce({})
            }).catch(err => {
                console.error(err)
                message.warning(err?.message)
            })
        )
        if (!needConfirm) {
            return onOk()
        }
        PSAIModal.confirm({
            title: '是否确定将该图像标记为通过',
            okText: '通过',
            cancelText: '取消',
            onOk () {
                return onOk()
            },
        })
    }, [])

    return (
        <div className={styles.DeliveryDetail}>
            <div className={styles.DeliveryDetailTitle}>
                <div>{version}</div>
                <DeliveryDetailActions
                    viewMode={viewMode}
                    onViewModeChange={onViewModeChange}
                    selectRowKeys={selectRowKeys}
                    isMultiSelect={isMultiSelect}
                    submitStatus={submitStatus}
                    onDownload={onDownload}
                    onSubmit={handleSubmitCurrentVersion}
                    onMultiSelect={onMultiSelect}
                    onSelectAll={onSelectAll}
                    onMultiSubmit={onMultiSubmit}
                />
            </div>
            <div className={styles.DeliveryDetailDashboard}>
                <span>商品: {deliveryInfo?.skuNum || 0}个</span>
                <span>交付总数: {deliveryInfo?.deliveryNum || 0}张</span>
                <span>待验收: {deliveryInfo?.waitCheckNum || 0}张</span>
                {deliveryInfo?.acceptedNum ? <span>已通过: {deliveryInfo?.acceptedNum || 0}张</span> : null}
                {deliveryInfo?.processNum ? <span>不通过: {deliveryInfo?.processNum || 0}张</span> : null}
                {deliveryInfo?.cancelNum ? <span>已取消: {deliveryInfo?.cancelNum || 0}张</span> : null}
            </div>
            <div id="scrollableDiv" className={`${styles.DeliveryDetailContent} _beauty_scrollbar`}>
                <InfiniteScroll
                    dataLength={dataSource.length} //This is important field to render the next data
                    next={fetchData}
                    hasMore={hasMore}
                    loader={<h4>loading...</h4>}
                    scrollableTarget="scrollableDiv"
                    endMessage={
                        <p style={{ height: "50px", lineHeight: "50px", textAlign: 'center', color: '#cccccc' }}>
                            <span>没有更多内容了</span>
                        </p>
                    }
                >
                {
                    viewMode == 1 ? 
                    <div className={styles.DeliveryItemList}>
                    {
                        dataSource.map(item => (
                            item.skuDeliveryList.map(item2 => (
                                <DeliveryItem
                                    key={item2.id}
                                    item={item2}
                                    onPreview={handlePreview}
                                    onSubmit={handleFeedbackSubmit}
                                    onDownload={handleDownload}
                                    onImageDownload={handleImageDownload}
                                    isMultiSelect={isMultiSelect}
                                    selectRowKeys={selectRowKeys}
                                    onSelect={onSelect}
                                    onRefresh={() => updateForce({})}
                                />
                            ))
                        ))
                    }
                    </div> :
                    viewMode == 2 || viewMode == 3 ?
                    <div className={`${styles.DeliveryImageList} ${viewMode == 3 ? styles.DeliveryImageListSmall : ''}`}>
                    {
                        imageList.map(item => (
                            <div key={item.imageId}>
                                <DeliveryImageItem
                                    key={item.imageId}
                                    item={item}
                                    onPreview={(data) => handlePreview({...data, spuId: item.spuCode})}
                                    onPass={(imageId, needConfirm) => handleApprove(imageId, item.deliveryId, needConfirm)}
                                    onDownload={handleImageDownload}
                                    isImageMultiSelect={viewMode == 1 ? false : isMultiSelect}
                                    selectImageKeys={viewMode == 1 ? [] : selectRowKeys}
                                    onSelect={onSelect}
                                />
                            </div>
                        ))
                    }
                    </div> : null
                }
                </InfiniteScroll>
            </div>
            <Modal
                open={pictureViewOpen}
                footer={null}
                mask={{closable: false}}
                keyboard={false}
                focusable={{trap: false}}
                closeIcon={false}
                destroyOnHidden
                width="100vw"
                style={{ top: 0, maxWidth: '100vw'}}
                styles={{
                    wrapper: { overflow: "hidden" },
                    container: {padding: 0, borderRadius: 0},
                    content: { padding: 0, borderRadius: 0 },
                    body: { height: "100vh", overflow: "hidden", padding: 0 }
                }}
                onCancel={onPreviewClose}
            >
                <PictureViewer
                    defaultIndex={pictureViewDefaultIndex}
                    defaultImages={pictureViewData}
                    submitOnSwitch
                    allowStatusDeselect={false}
                    requireRejectedAnnotationBeforeSwitch
                    onCancel={onPreviewClose}
                    onStatusChange={handlePictureStatusChange}
                />
            </Modal>
            <PSAIModal
                title="修改意见"
                width={556}
                open={multiRejectOpen}
                confirmLoading={multiRejectLoading}
                destroyOnClose
                onOk={handleMultiRejectSubmit}
                onCancel={() => setMultiRejectOpen(false)}
            >
                <div className={styles.RejectForm}>
                    <div>选择【不通过】时，必须填写修改意见</div>
                    <Input.TextArea
                        placeholder="请详细描述您的修改意见..."
                        autoSize={{ minRows: 5, maxRows: 5 }}
                        value={multiRejectReason}
                        onChange={e => setMultiRejectReason(e.target.value)}
                    />
                </div>
            </PSAIModal>
        </div>
    )
})

export default DeliveryDetail

function submitConfirm(approvedCount, rejectedCount) {
    return new Promise((resolve, reject) => {
        PSAIModal.confirm({
            content: (
                <div className={styles.SubmitConfirm}>
                    <div>
                        所有图片均已验收，点击<strong>提交反馈</strong>将进入后续流程
                    </div>
                    <div className={styles.InfoBox}>
                        {approvedCount > 0 && <div>
                            <span>已通过图片数量</span>
                            <span style={{color: "#43C287"}}>{approvedCount}张</span>
                        </div>}
                        {rejectedCount > 0 && <div>
                            <span>不通过图片数量</span>
                            <span style={{color: "#FF4D4F"}}>{rejectedCount}张</span>
                        </div>}
                    </div>
                    <div>
                        提交后，已通过的图片不可再修改审核状态
                    </div>
                </div>
            ),
            okText: '提交反馈',
            cancelText: '暂不提交',
            onOk () {
                resolve(true)
            },
            onCancel () {
                resolve(false)
            }
        })
    })
}

function isCommentAnnotation(item) {
    if (!item || typeof item !== 'object') return false
    return (!!item.label || !!item.text || !!item.comment) && !item.snapshot
}

function getNoCommentAnnotations(annotations = []) {
    return annotations.filter(item => !isCommentAnnotation(item))
}
